import(/* webpackMode: "eager" */ "/app/app/page.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BarTopNewSite.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/CarouselOwlHGames.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/GuestLobbyBanner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/HomePromoCoupon.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/new-components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/new-components/HomeHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/new-components/Particles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/new-components/Preloader.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/NflWeek1Banner/NflWeek1Banner.jsx");
